import { JetView } from 'webix-jet'; // Importing JetView for creating a Webix view
import { getCities } from 'models/cities'; // Importing function to get cities data
import { getTags } from 'models/tags'; // Importing function to get tags data
import { getPositions } from 'models/positions'; // Importing function to get positions data
import 'webix/photo'; // Importing Webix photo component
import 'webix/tinymce/tinymce'; // Importing TinyMCE editor from Webix
import { devConfig } from 'config/config'; // Importing development configuration
import { profile } from 'config/config'; // Importing user profile configuration

export default class InformationView extends JetView {
    /**
     * Configures the layout of the InformationView.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Get the current screen size

        const main_info = {
            // Main information form
            margin: 10,
            rows: [
                {
                    view: 'text', // Text input for ID
                    name: 'Id',
                    label: _("<span class='icon-id'></span> ID"),
                    labelPosition: 'top',
                    placeholder: _('Id'),
                    invalidMessage: _('A ID is required'),
                    disabled: true, // Disabled field
                },
                {
                    view: 'text', // Text input for Name
                    name: 'Name',
                    label: "<span class='icon-user'></span>" + _('Nombre'),
                    labelPosition: 'top',
                    placeholder: _('Nombre'),
                    invalidMessage: _('A name is required'),
                    disabled: true, // Disabled field
                },
                {
                    view: 'text', // Text input for Description
                    name: 'Description',
                    label: _('Segundo Nombre'),
                    labelPosition: 'top',
                    placeholder: _('Segundo Nombre'),
                    invalidMessage: _('A name is required'),
                    disabled: true, // Disabled field
                },
                {
                    view: 'richselect', // Dropdown for TypeProduct
                    name: 'TypeProduct',
                    label: _('Tipo de Producto'),
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                    options: [
                        { id: 'D', value: _('Deportivo') },
                        { id: 'C', value: _('Casino') },
                    ],
                    disabled: true, // Disabled field
                },
            ],
        };

        const notifications = {
            // Radio buttons for notifications
            view: 'radio',
            name: 'notifications',
            label: _('Notificaciones'),
            labelPosition: 'top',
            value: 1, // Default value
            options: [
                { id: 1, value: _('Si') },
                { id: 2, value: _('No') },
            ],
        };

        const left_main = {
            // Left section layout
            gravity: 3,
            minWidth: 200,
            margin: 10,
            rows: [main_info],
        };

        const more_info = {
            // Additional information form
            gravity: 3,
            minWidth: 200,
            margin: 10,
            rows: [
                {
                    view: 'richselect', // Dropdown for IsActivate
                    name: 'IsActivate',
                    label: _('Estado'),
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                    options: [
                        { id: '', value: _('Todo') },
                        { id: 'A', value: _('Activado') },
                        { id: 'C', value: _('Cancelado') },
                        { id: 'I', value: _('Inactivado') },
                    ],
                    disabled: true, // Disabled field
                },
                {
                    view: 'text', // Text input for DateStart
                    name: 'DateStart',
                    label: _('Fecha Inicio'),
                    labelPosition: 'top',
                    placeholder: 'Fecha Inicio',
                    disabled: true, // Disabled field
                },
                {
                    view: 'text', // Text input for DateEnd
                    name: 'DateEnd',
                    label: _('Fecha Fin'),
                    labelPosition: 'top',
                    placeholder: 'Fecha Fin',
                    disabled: true, // Disabled field
                },
                {
                    view: 'richselect', // Dropdown for Partner
                    name: 'Partner',
                    label: _('Partner'),
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '),
                    value: profile.PartnerSelected, // Default selected value
                    options: profile.Partners, // Options from profile
                    id: 'Partners',
                    disabled: true, // Disabled field
                },
            ],
        };

        const right_photo = {
            // Right section for photo and tags
            gravity: 3,
            margin: 10,
            rows: [
                {
                    view: 'photo', // Photo component
                    name: 'photo',
                    css: 'form_photo',
                    width: 260,
                    height: 260,
                    borderless: true,
                },
                {
                    view: 'multicombo', // Multi-select for tags
                    name: 'tags',
                    localId: 'tags:combo',
                    placeholder: _('Click to add tags'),
                    options: [],
                },
            ],
        };

        const upper_section = {
            // Upper section layout for larger screens
            multiview: true,
            padding: 10,
            cols: [left_main, { gravity: 0, minWidth: 20 }, more_info],
        };

        const upper_section_narrow = {
            // Upper section layout for smaller screens
            cols: [
                {
                    gravity: 4,
                    margin: 10,
                    rows: [main_info, more_info],
                },
            ],
        };

        const buttons = {
            // Button section
            margin: 10,
            cols: [
                {},
                {
                    view: 'button', // Save button
                    value: _('Guardar'),
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        // Click event for saving data
                        if (this.getRoot().validate()) {
                            // Validate form
                            const newdata = this.getRoot().getValues(); // Get form values
                            this.app.callEvent('customer:save', [newdata]); // Trigger save event
                        }
                    },
                },
            ],
        };

        webix.ui.fullScreen(); // Set the UI to full screen mode

        return {
            // Return the main form configuration
            view: 'form',
            rows: [
                screen !== 'small' ? upper_section : upper_section_narrow, // Conditional layout based on screen size
                buttons,
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} form - The form instance to initialize.
     */
    init(form) {
        var vthis = this; // Reference to the current instance

        this.on(this.app, 'form:update2', (id) => {
            // Event listener for updating form data
            webix.ajax().get(
                devConfig.geturlApi() + 'League/GetLeagueById', // API call to get league data
                'id=' + id,
                {
                    error: function (text, data, XmlHttpRequest) {
                        // Error handling
                        webix.message('Error! ');
                    },
                    success: function (text, data, XmlHttpRequest) {
                        // Success handling
                        text = JSON.parse(text); // Parse response
                        vthis.app.callEvent('customer:updatedata', [
                            text[0], // Trigger update event with data
                        ]);
                        $$('country').setValue(text[0].CountryId); // Set country value
                        webix.delay(
                            function () {
                                $$('ProvinceRegion').setValue(
                                    text[0].RegionId, // Set region value
                                );
                                webix.delay(
                                    function () {
                                        $$('City').setValue(text[0].CityId); // Set city value
                                    },
                                    '',
                                    '',
                                    1000, // Delay for setting city value
                                );
                            },
                            '',
                            '',
                            1000, // Delay for setting region value
                        );
                    },
                },
            );
        });

        webix
            .ajax()
            .headers({
                'Content-type': 'application/json', // Set content type for the request
            })
            .post(devConfig.geturlApi() + 'Agent/GetAgentCountries', '', {
                error: function (text, data, XmlHttpRequest) {
                    // Error handling
                    webix.message('Error! ');
                },
                success: function (text, data, XmlHttpRequest) {
                    // Success handling
                    var data = JSON.parse(
                        text
                            .replace(/"Id"/g, '"id"') // Normalize response keys
                            .replace(/"Name"/g, '"value"'),
                    );
                },
            });

        this.on(
            this.app,
            'customer:updatedata',
            (
                person, // Event listener for updating form with person data
            ) => form.setValues(person),
        );
        this.on(this.app, 'person:select', (person) => form.setValues(person)); // Event listener for selecting a person
    }

    /**
     * Retrieves and sets localized options for combo boxes.
     */
    getLocalizedComboOptions() {
        const _ = this.app.getService('locale')._; // Localization service
        let p_options = webix.copy(getPositions()); // Get positions options
        p_options.map((x) => (x.value = _(x.value))); // Localize position values
        this.$$('position:combo').getPopup().getList().parse(p_options); // Set position options in combo

        let t_options = webix.copy(getTags()); // Get tags options
        t_options.map((x) => (x.value = _(x.value))); // Localize tag values
        this.$$('tags:combo').getPopup().getList().parse(t_options); // Set tag options in combo

        let c_options = webix.copy(getCities()); // Get cities options
        c_options.map((x) => (x.value = _(x.value))); // Localize city values
        this.$$('cities:combo').getPopup().getList().parse(c_options); // Set city options in combo
    }
}

// FILE DOCUMENTED
